// COLORS
export const BoschColor = {
    // Bosch Red gradations
    bosch_red_w75: "#FABFC5",
    bosch_red_w50: "#F4808B",
    bosch_red_w25: "#EF4050",
    bosch_red: "#EA0016",
    bosch_red_b25: "#B00010",
    bosch_red_b50: "#75000B",
    bosch_red_b75: "#3A0006",

    // Bosch Fuchsia gradations
    bosch_fuchsia_w75: "#EDC0DD",
    bosch_fuchsia_w50: "#DC80BA",
    bosch_fuchsia_w25: "#CB4198",
    bosch_fuchsia: "#B90276",
    bosch_fuchsia_b25: "#8B0158",
    bosch_fuchsia_b50: "#5D013B",
    bosch_fuchsia_b75: "#2E011E",

    // Bosch Violet gradations
    bosch_violet_w75: "#D3C8DF",
    bosch_violet_w50: "#A791BF",
    bosch_violet_w25: "#7C5A9F",
    bosch_violet: "#50237F",
    bosch_violet_b25: "#3C1A5F",
    bosch_violet_b50: "#281240",
    bosch_violet_b75: "#140920",

    // Bosch Dark Blue gradations
    bosch_dark_blue_w75: "#BFD5E3",
    bosch_dark_blue_w50: "#7FAAC8",
    bosch_dark_blue_w25: "#4080AD",
    bosch_dark_blue: "#005691",
    bosch_dark_blue_b25: "#00406D",
    bosch_dark_blue_b50: "#002B49",
    bosch_dark_blue_b75: "#001624",

    // Bosch Light Blue gradations
    bosch_light_blue_w75: "#BFE3F3",
    bosch_light_blue_w50: "#7FC6E7",
    bosch_light_blue_w25: "#40AADB",
    bosch_light_blue: "#008ECF",
    bosch_light_blue_b25: "#006A9B",
    bosch_light_blue_b50: "#004768",
    bosch_light_blue_b75: "#002434",

    // Bosch Turquoise gradations
    bosch_turquoise_w75: "#BFE9EB",
    bosch_turquoise_w50: "#7FD3D7",
    bosch_turquoise_w25: "#40BEC4",
    bosch_turquoise: "#00A8B0",
    bosch_turquoise_b25: "#007E84",
    bosch_turquoise_b50: "#005458",
    bosch_turquoise_b75: "#002A2C",

    // Bosch Light Green gradations
    bosch_light_green_w75: "#DDEFC7",
    bosch_light_green_w50: "#BBDE8F",
    bosch_light_green_w25: "#9ACE58",
    bosch_light_green: "#78BE20",
    bosch_light_green_b25: "#5A8E18",
    bosch_light_green_b50: "#3C5F10",
    bosch_light_green_b75: "#1E3008",

    // Bosch Dark Green gradations
    bosch_dark_green_w75: "#BFD8D1",
    bosch_dark_green_w50: "#7FB0A4",
    bosch_dark_green_w25: "#408977",
    bosch_dark_green: "#006249",
    bosch_dark_green_b25: "#004937",
    bosch_dark_green_b50: "#003125",
    bosch_dark_green_b75: "#001912",

    // Bosch Light Gray gradations
    bosch_light_gray_w75: "#EFEFF0",
    bosch_light_gray_w50: "#DFDFE0",
    bosch_light_gray_w25: "#CFD0D1",
    bosch_light_gray: "#BFC0C2",
    bosch_light_gray_b25: "#8F9091",
    bosch_light_gray_b50: "#606061",
    bosch_light_gray_b75: "#303031",

    // Bosch Dark Gray gradations
    bosch_dark_gray_w75: "#D4D7DA",
    bosch_dark_gray_w50: "#A8AFB5",
    bosch_dark_gray_w25: "#7D8790",
    bosch_dark_gray: "#525F6B",
    bosch_dark_gray_b25: "#3D4750",
    bosch_dark_gray_b50: "#293036",
    bosch_dark_gray_b75: "#15181B",

    // Bosch Yellow gradations
    bosch_yellow_w75: "#FEEBC5",
    bosch_yellow_w50: "#FDD78B",
    bosch_yellow_w25: "#FDC351",
    bosch_yellow: "#FCAF17",
    bosch_yellow_b25: "#BD8311",
    bosch_yellow_b50: "#7E580C",
    bosch_yellow_b75: "#3F2C06",

    // Black & White
    bosch_black: "#000000",
    bosch_white: "#FFFFFF",
}